import { useState } from "react";
import { resumenMutuoModel } from "../models/resumenMutuoModel";
import { getTablaDetalleLiquidacion, getDatosTabla, getDetalleLiquidacion, getEstadoMutuo, getFechaActivacion, getResumenMutuo, crearBeneficiarioLiquidacion, actualizarBeneficiarioLiquidacion, eliminarBeneficiarioLiquidacion, calcularMontoAPagar, liquidarMutuo, desliquidarMutuo } from "../services/serviceLiquidacion";
import { tablaDesarrolloLiquidacionModel } from "../models/tablaDesarrolloLiquidacionModel";
import { EstadosMutuo } from "../enums/estadosMutuo";
import { formularioLiquidacionModel } from "../models/formularioLiquidacionModel";
import { HeaderComprobanteLiquidacion, RowComprobanteLiquidacion } from "../models/headerComprobanteLiquidacion";
import { FormularioBeneficiarioModel } from "../models/formularioBeneficiarioModel";
import { TipoBeneficiario } from "../enums/tipoBeneficiario";
import { CalculoMontoInputDto } from "../models/calculoMontoModel";
import { safeLog } from "../../../utils/logSafe";

export function UseLiquidacion() {
    const [defaultValues, setDefaultValues] = useState<resumenMutuoModel>({
        mutuoId: undefined,
        numeroOperacion: '',
        rut: '',
        nombreCliente: '',
        telefono: '',
        direccion: '',
        ciudad: '',
        comuna: '',
        tipoProducto: '',
        objetivoMutuo: '',
        montoOriginal: 0,
        saldoInsoluto: 0,
        numDividendos: 0,
        numDivPagados: 0,
        numDivNoPagados: 0,
        postergacionDiv: '',
        fechaPrimeraFirma: null,
        fechaEndoso: null,
        fechaActivacion: null,
        tasa: 0,
        plazo: 0,
        rutDuenoGarantia: '',
        nombreDuenoGarantia: '',
        numeroSerie: '',
        fechaProtocolizacion: null,
        numeroProtocolizacion: 0,
        numeroRepertorio: ''
    });

    const [defaultValuesTabla, setDefaultValuesTabla] = useState<tablaDesarrolloLiquidacionModel>({
        mutuoId: undefined,
        numeroSerie: '',
        fechaProtocolizacion: null,
        numeroProtocolizacion: 0,
        numeroRepertorio: ''
    })

    const [defaultValuesLiquidacion, setDefaultValuesLiquidacion] = useState<formularioLiquidacionModel>({
        mutuoId: undefined,
        numeroOperacion: '',
        rut: '',
        nombre: '',
        direccionGarantia: '',
        comunaGarantia: '',
        ciudadGarantia: '',
        fechaActivacion: null,
        tasa: 0,
        plazo: 0,
        montoInicial: 0,
        fechaEscritura: null,
        rutDuenoGarantia: '',
        nombreDuenoGarantia: '',
        montoLiquidacion: 0
    })

    const [defaultValuesHeaderComprobante, setDefaultValuesHeaderComprobante] = useState<HeaderComprobanteLiquidacion>({
        mutuoId: undefined,
        montoPago: 0,
        fechaLiquidacion: new Date(),
        filasMutuosLiquidaciones: []
    })

    const [defaultValuesRowBeneficiario, setDefaultValuesRowBeneficiario] = useState<FormularioBeneficiarioModel>({
        rut: "",
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        monto: 0,
        tipoBeneficario: TipoBeneficiario.PERSONA_NATURAL,
        institucion: "",
        inmobiliaria: "",
        participante: ""
    })

    const [esLiquidado, setEsLiquidado] = useState<Boolean | null>(null);
    const [esActivado, setEsActivado] = useState<Boolean | null>(null);

    const [fechaActivacion, setFechaActivacion] = useState<Date | null>(null);

    const getResumenLiquidacion = async (idMutuo: number) => {
        const response = await getResumenMutuo(idMutuo);
        const data = response.data;
        if (!data.saldoInsoluto) data.saldoInsoluto = 0;
        if (!data.numDividendos) data.numDividendos = 0;
        if (!data.numDivNoPagados) data.numDivNoPagados = 0;
        if (!data.numDivPagados) data.numDivPagados = 0;

        const tablaResponse = await getDatosTabla(idMutuo);

        data.numeroSerie = tablaResponse.data.numeroSerie;
        data.fechaProtocolizacion = tablaResponse.data.fechaProtocolizacion;
        data.numeroProtocolizacion = tablaResponse.data.numeroProtocolizacion;
        data.numeroRepertorio = tablaResponse.data.numeroRepertorio;

        setDefaultValues(data)
    }

    const getDatosTablaLiquidacion = async (idMutuo: number) => {
        const response = await getDatosTabla(idMutuo);
        const data = response.data;
        setDefaultValuesTabla(data);
    }

    const getEstadoMutuoLiquidacion = async (idMutuo: number) => {
        const response = await getEstadoMutuo(idMutuo);
        const data = response.data;
        safeLog(data)
        if (data.estadoActual) {
            setEsLiquidado(data.estadoActual === EstadosMutuo.LIQUIDADO)
            setEsActivado(data.estadoActual === EstadosMutuo.ACTIVADO)
        }
    }

    const getFormularioLiquidacion = async (idMutuo: number) => {
        const response = await getDetalleLiquidacion(idMutuo);
        const data = response.data;
        setDefaultValuesLiquidacion(data);
    }

    const getDetalleLiquidacionMutuo = async (idMutuo: number, isUpdatingBeneficiario: boolean, dateToMaintain: Date, montoToMaintain: number) => {
        const response = await getTablaDetalleLiquidacion(idMutuo);
        const data = response.data;
        if (isUpdatingBeneficiario) {
            data.fechaLiquidacion = dateToMaintain
            data.montoPago = montoToMaintain
        }
        else {
            data.fechaLiquidacion = data.fechaLiquidacion != null && data.fechaLiquidacion != undefined ? data.fechaLiquidacion : new Date();
        }
        safeLog("FORMULARIO: ", data)
        console.log('data', data)
        setDefaultValuesHeaderComprobante(data)
    }

    const getFechaActivacionMutuo = async (idMutuo: number) => {
        const response = await getFechaActivacion(idMutuo);
        const data = response.data;
        setFechaActivacion(data.fechaActivacion);
    }

    const agregarBeneficiario = async (idMutuo: number, formulario: FormularioBeneficiarioModel) => {
        const body: RowComprobanteLiquidacion = {
            rut: formulario.rut, nombre: formulario.nombre, apellidoPaterno: formulario.apellidoPaterno,
            apellidoMaterno: formulario.apellidoMaterno, tipoBeneficiario: formulario.tipoBeneficario, monto: formulario.monto
        }
        const response = await crearBeneficiarioLiquidacion(idMutuo, body);
        return response;
    }

    const actualizarBeneficiario = async (idMutuo: number, formulario: FormularioBeneficiarioModel) => {
        const body: RowComprobanteLiquidacion = {
            rut: formulario.rut, rutOriginal: formulario.rutOriginal, nombre: formulario.nombre,
            apellidoPaterno: formulario.apellidoPaterno, apellidoMaterno: formulario.apellidoMaterno,
            tipoBeneficiario: formulario.tipoBeneficario, monto: formulario.monto
        }
        const response = await actualizarBeneficiarioLiquidacion(idMutuo, body);
        return response;
    }

    const eliminarBeneficiario = async (idMutuo: number, rut: string) => {
        const response = await eliminarBeneficiarioLiquidacion(idMutuo, rut);
        return response;
    }

    const calcularMontoAPagarLiquidacion = async (idMutuo: number, fechaLiquidacion: Date) => {
        const calculoRequest: CalculoMontoInputDto = { mutuoId: idMutuo, fechaLiquidacion: fechaLiquidacion }
        const response = await calcularMontoAPagar(calculoRequest)
        return response;
    }

    const liquidarMutuoEnLiquidacion = async (idMutuo: number, fechaLiquidacion: Date) => {
        const response = await liquidarMutuo(idMutuo, fechaLiquidacion);
        return response;
    }

    const desliquidarMutuoEnLiquidacion = async (idMutuo: number) => {
        const response = await desliquidarMutuo(idMutuo);
        return response;
    }


    return {
        defaultValues,
        defaultValuesTabla,
        defaultValuesLiquidacion,
        defaultValuesHeaderComprobante,
        defaultValuesRowBeneficiario,
        esLiquidado,
        esActivado,
        fechaActivacion,
        setDefaultValues,
        setDefaultValuesHeaderComprobante,
        setDefaultValuesRowBeneficiario,
        getResumenLiquidacion,
        getDatosTablaLiquidacion,
        getEstadoMutuoLiquidacion,
        getFormularioLiquidacion,
        getDetalleLiquidacionMutuo,
        getFechaActivacionMutuo,
        agregarBeneficiario,
        actualizarBeneficiario,
        eliminarBeneficiario,
        calcularMontoAPagarLiquidacion,
        liquidarMutuoEnLiquidacion,
        desliquidarMutuoEnLiquidacion
    }
}